<!--  用户列表 -->
<template>
  <qc-container title="账号管理" >
    <search-box @reset-search="baseResetSearch" @action="loadData" v-model="searchObj.userName" placeholder="请输入用户名称/手机号搜索">
      <template  #form-item>
        <el-form-item label="用户名称" >
          <el-input  style="width:240px" v-model="searchObj.userName" placeholder="`请输入用户名/手机号称搜索`"
                     @keyup.enter.native="loadData()"></el-input>
        </el-form-item>
        <el-form-item label="用户状态" >
          <simple-dict style="width:240px" v-model="searchObj.status" dict-type="status"></simple-dict>
        </el-form-item>
      </template>
      <t-button @click="editUser()">添加用户</t-button>
      <!--<t-button v-premission="'changeUserStatus'" @click="batchChangeUserStatus(1)">停用</t-button>
      <t-button v-premission="'changeUserStatus'" @click="batchChangeUserStatus(0)">启用</t-button>-->
    </search-box>
    <el-table :data="tableData" style="width: 100%"  v-loading="loading" @selection-change="selectionBaseChange"  element-loading-text="拼命加载中">
      <el-table-column type="selection"></el-table-column>
      <el-table-column prop="nickName" label="用户名称" width="180"></el-table-column>
      <el-table-column prop="userName" label="登录账号" width="180"></el-table-column>
      <el-table-column prop="mobile" label="手机号" width="180"></el-table-column>
      <el-table-column prop="groupName" label="角色名称" width="180"></el-table-column>
      <el-table-column prop="statusDesc" label="状态" width="180"></el-table-column>
      <el-table-column label="操作">
        <template #default="scope">
          <b-button v-show="scope.row.status==0"  @click="changeUserStatus(1,scope.row.id)">停用</b-button>
          <b-button v-show="scope.row.status==1"  @click="changeUserStatus(0,scope.row.id)">启用</b-button>
          <b-button @click="editUser(scope.row.id)">编辑</b-button>
          <b-button @click="delUser(scope.row.id)" type-class="red">删除</b-button>
        </template>
      </el-table-column>
    </el-table>
    <page ref="page" @handle-page="handlePage"></page>
  </qc-container>
</template>

<script>
  import Page from "../../../components/base/page";
  import SimpleDict from "../../../components/dict/SimpleDict";
  import QcContainer from "../../../components/el/layout/qc-container";
  import SearchBox from "../../../components/base/SearchBox";
  import TButton from "../../../components/el/t-button";
  import BButton from "../../../components/el/b-button";
  export default {
    name: "list",
    components: {BButton, TButton, SearchBox, QcContainer, SimpleDict, Page},
    data() {
      return {
        loading: false,
        selectItems:[],
        searchObj: {userName:'',status:'',source:source,isSuper:0},
        tableData: []
      }
    },
    mixins: [tableBase],
    methods: {
      loadData(){
        this.searchObj.isSuper = 0 ;
        this.loadPageData(Api.user+"list");
      },
      editUser(id){
        if($.isNotEmpty(id)){
          this.$router.push({path: '/index/user/add',query:{id:id}})
        }else{
          this.$router.push({path: '/index/user/add'});
        }
      },
      delUser(id){
        this.msgConfirm(Api.user+"/delete",{id:id},result=>{
          this.loadData();
        });
      },
      batchChangeUserStatus(status){
        let msg = status == 1?'停用':'启用';
        let ids = this.getItems();
        this.deleteConfirm(Api.user+"changeUserStatus",{ids:ids,status:status},result=>{
          this.loadData();
        },"是否"+msg+"该用户?");
      },
      changeUserStatus(status,id){
        let msg = status == 1?'停用':'启用';
        let ids = [];
        ids.push(id);
        this.msgConfirm(Api.user+"changeUserStatus",{ids:ids,status:status},result=>{
          this.loadData();
        },"是否"+msg+"用户?");
      }
    },
    mounted() {
      this.loadData();
    }
  }
</script>


<style lang="less" scoped>

</style>
